// Papierschmiede — Umriss-Bullets je Option (sections/ps-reiseziele.liquid), Marcel 21.10.2026.
// Vertrag mit dem Customizer: Klick → ?variant=<id> (replaceState), erstes Galeriebild auf das Ziel,
// Ereignis ps:variante {id, sku}. Auf ps:ziel {nummer, variantId} ziehen Bullets, Größenwahl und Bild mit.
if (!customElements.get('ps-reiseziele')) {
  customElements.define('ps-reiseziele', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.buttons = [...this.querySelectorAll('[data-ps-ziel]')];
      this.lesen();
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-ps-ziel]');
        if (!button) return;
        this.sucheLeeren?.();
        this.waehle(button.dataset.psZiel, { melden: true });
      }, options);
      this.suche(options);
      // Bild des Ziels vorladen, sobald der Zeiger oder der Fokus auf dem Umriss ist.
      const vorladen = (event) => {
        const button = event.target.closest?.('[data-ps-ziel]');
        if (button?.dataset.bild && !button.dataset.geladen) { button.dataset.geladen = '1'; new Image().src = button.dataset.bild; }
      };
      this.addEventListener('pointerover', vorladen, options);
      this.addEventListener('focusin', vorladen, options);
      // Größenwahl der Produktseite (ps-format-wahl): Adresse folgt der Variante.
      document.addEventListener('change', (event) => {
        if (event.target.matches('.ps-map-format input[data-ps-groesse]')) this.adresse(event.target.value);
      }, options);
      document.addEventListener('ps:ziel', (event) => this.vomDesigner(event.detail || {}), options);
      this.sichtbar(this.querySelector('[aria-pressed="true"]'), true);
    }

    disconnectedCallback() { this.abort?.abort(); }

    // Suchfeld über den Kacheln (Marcel 22.10.2026): filtert beim Tippen, Reihenfolge bleibt. Ohne Groß/klein, Umlaute als
    // ae/oe/ue oder ohne Punkte, ß als ss, andere Namen aus der Section-Einstellung (Holland=Niederlande). Ein Treffer + Enter
    // wählt wie ein Kachelklick. Kein Treffer: Hinweis mit Kontaktlink, alle Kacheln bleiben sichtbar (ruhiger als eine leere
    // Fläche, und die Auswahl steht gleich daneben). Die Liste behält beim Filtern ihre Höhe, damit die Seite nicht springt.
    suche(options) {
      const feld = this.querySelector('[data-ps-suche]');
      if (!feld) return;
      const leeren = this.querySelector('[data-ps-suche-leeren]');
      const keiner = this.querySelector('[data-ps-keiner]');
      const status = this.querySelector('[data-ps-treffer]');
      const liste = this.querySelector('.ps-reiseziele__liste');
      const norm = (text, umlaut) => {
        let s = String(text || '').toLowerCase().replace(/ß/g, 'ss').trim().replace(/\s+/g, ' ');
        if (umlaut) s = s.replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue');
        return s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      };
      const andere = {};
      for (const eintrag of (feld.dataset.synonyme || '').split(',')) {
        const [namen, ziel] = eintrag.split('=').map((s) => (s || '').trim());
        if (!namen || !ziel) continue;
        (andere[ziel] ||= []).push(...namen.split('|').map((s) => s.trim()).filter(Boolean));
      }
      const formen = new Map(this.buttons.map((b) => {
        const namen = [b.dataset.psZiel, ...(andere[b.dataset.psZiel] || [])];
        return [b, [...new Set(namen.flatMap((n) => [norm(n, true), norm(n, false)]))]];
      }));
      // Ein Zeichen: nur der Anfang des Ländernamens („s“ zeigt nicht die USA über „Vereinigte Staaten“).
      const eigene = new Map(this.buttons.map((b) => [b, [norm(b.dataset.psZiel, true), norm(b.dataset.psZiel, false)]]));
      const passt = (liste_, q) => liste_.some((f) => f.startsWith(q) || f.split(/[\s-]/).some((w) => w.startsWith(q)) || (q.length >= 3 && f.includes(q)));
      let treffer = [];
      const filtern = () => {
        const roh = feld.value;
        leeren.hidden = !roh;
        const qa = norm(roh, true);
        const qb = norm(roh, false);
        if (!qa) {
          this.buttons.forEach((b) => { b.hidden = false; });
          keiner.hidden = true; status.textContent = ''; liste.style.minHeight = ''; treffer = [];
          liste.classList.remove('is-gefiltert');
          return;
        }
        if (!liste.style.minHeight) liste.style.minHeight = `${liste.offsetHeight}px`;
        treffer = qa.length === 1
          ? this.buttons.filter((b) => eigene.get(b).some((f) => f.startsWith(qa) || f.startsWith(qb)))
          : this.buttons.filter((b) => passt(formen.get(b), qa) || passt(formen.get(b), qb));
        if (treffer.length === 0) {
          this.buttons.forEach((b) => { b.hidden = false; });
          keiner.hidden = false;
          status.textContent = keiner.textContent.trim();
        } else {
          this.buttons.forEach((b) => { b.hidden = !treffer.includes(b); });
          keiner.hidden = true;
          status.textContent = treffer.length === 1 ? status.dataset.eins : status.dataset.mehr.replace('[anzahl]', treffer.length);
        }
        liste.classList.toggle('is-gefiltert', treffer.length > 0);
        liste.scrollLeft = 0;
      };
      this.sucheLeeren = () => {
        if (!feld.value) return;
        feld.value = '';
        filtern();
      };
      feld.addEventListener('input', filtern, options);
      feld.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') { this.sucheLeeren(); return; }
        if (event.key !== 'Enter') return;
        event.preventDefault();
        if (treffer.length !== 1) return;
        const ziel = treffer[0];
        this.sucheLeeren();
        this.waehle(ziel.dataset.psZiel, { melden: true });
        ziel.focus({ preventScroll: true });
      }, options);
      leeren.addEventListener('click', () => { this.sucheLeeren(); feld.focus({ preventScroll: true }); }, options);
    }

    // Alle Varianten aus dem Metafeld (Shopify gibt im Theme höchstens 250 heraus).
    lesen() {
      this.karte = new Map();
      this.nachId = new Map();
      const quelle = this.querySelector('script[data-ps-varianten]');
      if (!quelle) return;
      try {
        const daten = JSON.parse(quelle.textContent);
        const index = daten.optionen.indexOf(this.dataset.option);
        if (index < 0) return;
        for (const [id, sku, ...werte] of daten.varianten) {
          const ziel = werte[index];
          const rest = werte.filter((_, i) => i !== index).join(' | ');
          if (!this.karte.has(ziel)) this.karte.set(ziel, new Map());
          this.karte.get(ziel).set(rest, { id: String(id), sku });
          this.nachId.set(String(id), { ziel, rest, sku });
        }
      } catch (error) {
        this.karte.clear();
        this.nachId.clear();
      }
    }

    aktuelleId() {
      const format = document.querySelector('.ps-map-format input[data-ps-groesse]:checked');
      if (format) return format.value;
      return new URL(location.href).searchParams.get('variant')
        || this.querySelector('[aria-pressed="true"]')?.dataset.variante;
    }

    waehle(ziel, { melden = false, variantId = null } = {}) {
      const button = this.buttons.find((b) => b.dataset.psZiel === ziel);
      if (!button) return;
      const varianten = this.karte.get(ziel);
      if (!varianten) {
        // Ohne vollständige Liste: Seite mit der Variante neu laden (gleiche Größe wie beim Laden).
        if (melden && button.dataset.url && button.getAttribute('aria-pressed') !== 'true') location.href = button.dataset.url;
        return;
      }
      const jetzt = this.nachId.get(String(variantId || this.aktuelleId()));
      const ziel_variante = (variantId && this.nachId.has(String(variantId)) && varianten.get(this.nachId.get(String(variantId)).rest))
        || (jetzt && varianten.get(jetzt.rest))
        || varianten.values().next().value;
      this.buttons.forEach((b) => b.setAttribute('aria-pressed', String(b === button)));
      this.sichtbar(button);
      const name = this.querySelector('[data-ps-ziel-name]');
      if (name) name.textContent = ziel;
      this.groessen(varianten, ziel_variante.id);
      this.bild(button);
      this.adresse(ziel_variante.id);
      const block = document.querySelector('[data-twk-poster]');
      if (block) block.dataset.variante = ziel_variante.id;
      if (melden) document.dispatchEvent(new CustomEvent('ps:variante', { detail: { id: Number(ziel_variante.id), sku: ziel_variante.sku } }));
    }

    // Größenwahl auf das neue Ziel umstellen: gleiche Größe, Varianten-ID des Ziels.
    groessen(varianten, gewaehlt) {
      const vorher = document.querySelector('.ps-map-format input[data-ps-groesse]:checked');
      let jetzt = null;
      document.querySelectorAll('.ps-map-format input[data-ps-groesse]').forEach((input) => {
        const treffer = varianten.get(input.dataset.psGroesse);
        if (!treffer) return;
        input.value = treffer.id;
        if (treffer.id === String(gewaehlt)) { input.checked = true; jetzt = input; }
      });
      // Andere Größe (Wunsch des Designers): Preis und Größenberatung wie bei einer Wahl von Hand.
      if (jetzt && jetzt !== vorher) jetzt.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Erstes Galeriebild (ps-galerie-zielbild) zeigt das Ziel.
    bild(button) {
      if (!button.dataset.bild) return;
      document.querySelectorAll('[data-ps-zielbild]').forEach((ort) => {
        if (ort.matches('img')) {
          const url = new URL(button.dataset.bild, location.href);
          url.searchParams.set('width', '160');
          ort.src = url.href;
          return;
        }
        ort.style.backgroundImage = `url("${button.dataset.bild}")`;
        ort.setAttribute('aria-label', button.dataset.bildAlt || button.dataset.psZiel);
      });
      const track = document.querySelector('ps-map-gallery .ps-map-gallery__track');
      if (track && track.scrollLeft > 0) track.scrollTo({ left: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }

    // Handy: die Liste wischt waagerecht; das gewählte Ziel steht in ihrer Mitte (ohne die Seite zu scrollen).
    sichtbar(button, sofort = false) {
      const liste = this.querySelector('.ps-reiseziele__liste');
      if (!button || !liste || liste.scrollWidth <= liste.clientWidth) return;
      const b = button.getBoundingClientRect();
      const l = liste.getBoundingClientRect();
      const links = liste.scrollLeft + (b.left - l.left) - (liste.clientWidth - b.width) / 2;
      liste.scrollTo({ left: Math.max(0, links), behavior: sofort || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }

    adresse(id) {
      if (!id) return;
      const url = new URL(location.href);
      url.searchParams.set('variant', id);
      history.replaceState(history.state, '', url);
    }

    vomDesigner({ nummer, variantId }) {
      const id = variantId ? String(variantId) : null;
      const ziel = (id && this.nachId.get(id)?.ziel)
        || this.buttons.find((b) => b.dataset.nummer === String(nummer))?.dataset.psZiel;
      if (ziel) this.waehle(ziel, { melden: false, variantId: id });
    }
  });
}
